export const isZipDvbFile = (extension: string): boolean => isZipFile(extension) || isDvbFile(extension);

export const isZipFile = (extension: string): boolean => {
    return extension.toLowerCase() === "zip";
};

export const isDvbFile = (extension: string): boolean => {
    return extension.toLowerCase() === "dvb";
};
